export default "__VITE_ASSET__DRy2EHkT__"